// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function AtBoldIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M16 2.5a13.5 13.5 0 0 0 0 27c2.784 0 5.711-.841 7.83-2.25a1.5 1.5 0 0 0-1.661-2.5C20.544 25.829 18.183 26.5 16 26.5A10.5 10.5 0 1 1 26.5 16c0 1.161-.209 2.135-.586 2.744-.33.53-.75.756-1.414.756-.664 0-1.084-.226-1.414-.756-.375-.609-.586-1.583-.586-2.744v-5a1.5 1.5 0 0 0-2.936-.432 6.5 6.5 0 1 0 1.107 9.946c.867 1.274 2.18 1.986 3.829 1.986 3.084 0 5-2.49 5-6.5A13.515 13.515 0 0 0 16 2.5Zm0 17a3.5 3.5 0 1 1 0-7 3.5 3.5 0 0 1 0 7Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
